import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import Dropdown from "../../../primer/Dropdown";
import Input from '../../../common/Input';
import {
  getCountryOptions,
  getDefaultOptionByValue,
  getDOYOptions,
  getGeneratedMaskCodeCLient,
  getMainInstallation,
  getMaskCodeWithNewPrefix,
  getOptionsByData,
  getVatCategoryAbroadOptions,
  getVatCategoryOptions,
  isValidEmail, validateAFM
} from '../../../../_helpers/commonFunctions';
import { useSelector, useDispatch } from "react-redux";
import {setSaveNewSupplier} from "../../../../_reducers/activitySlice";
import { findObjectFromArrayOfObjects, getLabelByValue, getObjectFromArrayOfObjects } from '../../../../_helpers/helperFunctions';
import {fetchSuppliersSettings, fetchInitialSuppliers} from '../../../../_apis/api';
import './supplierModal.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import getMyData from "../../../../_helpers/sharedmydata";
import {resetNewSupplierModal, setNewSupplierModal} from "../../../../_reducers/DataPanel/Suppliers/supplierSlice";
import {useTranslation} from "../../../../hooks/useTranslation";
const apiURL2 = process.env.REACT_APP_API_URL2;

const NewSupplierModal = ({myDataType, successCallback}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const SUPPLIERS_DATA = useSelector( (state) => state.SUPPLIERS_DATA );
  const ACTIVITY = useSelector( (state) => state.ACTIVITY );
  const company = useSelector(state => state.COMPANY_DATA.company)
  let [supplierCategories,setSupplierCategories] = useState(getObjectFromArrayOfObjects(SUPPLIERS_DATA.suppliersSettings.categories, 'active', 'isActive'));
  const zeroVatReasonOptions = getMyData({type: 'zerovatreason'});
  const supplierCategoriesOption = getOptionsByData(supplierCategories, '_id', 'category');
  let vatCategoryList = SUPPLIERS_DATA.newSupplier.categoryName === "Supplier within E.U." || SUPPLIERS_DATA.newSupplier.categoryName === "Supplier outside E.U." ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
  const isValidCustomVat = (value) => {
    let error;
    if (+value > 100) {
      error = 'Can not be greater than 100.';
    }
    return error;
  }
  let requestData = {
    company:company.id,
    year:company.year,
  }
  useEffect(() => {
    // It will use for validate supplier name
    dispatch(
        fetchInitialSuppliers({
          company: company.id,
          year: company.year,
          isActive: "active",
        })
    );

    dispatch(
        fetchSuppliersSettings({
          company: company.id,
          year: company.year.toString(),
          isActive: "active"
        })
    );
  }, []);

  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [showErrors, setShowErrors] = useState(false)
  const [loadingSave, setLoadingSave] = useState(false);
  // let countryData = getCountryOptions(); // get all countries data
  // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.: Select Greece, Accept only Greece, show only Greece
  let countryData = getCountryOptions('greece'); // Only Greece Country Data
  let [countriesList, setCountriesList] = useState(countryData);
  // Data From The API
  let disabledFields = false;
  if (SUPPLIERS_DATA.newSupplierModal.category === undefined || SUPPLIERS_DATA.newSupplierModal.category === '') {
    disabledFields = true;
  }

  const handleOnChange = (e, type = "default", ddname = '') => {
    setShowErrors(true);
    // Set if editing the form
    if (!ACTIVITY.saveNewSupplier) dispatch(setSaveNewSupplier(true));

    let name;
    let value;

    if (type === 'dd') {
      name = ddname;
      value = e.value;
    } else if (type === 'ac') {
      name = ddname;
      value = e.row.value;
    } else {
      name = e.target.name;
      value = e.target.value;
    }
    if (name === 'customVat') {
      let error;
      if (+value > 100) {
        error = 'Can not be greater than 100.';
        toast.error(error);
        value = "";
      }
      value = +String(value).slice(0, 3);
      if (value === 0) {
        value = "";
      }
    }
    // Set settings data
    let newSupplier = Object.assign({}, SUPPLIERS_DATA.newSupplierModal);
    let newSupplierData = {};
    if (name === 'category') {
      newSupplierData[name] = value;
      newSupplierData.categoryName = getLabelByValue(supplierCategoriesOption, value, 'value');

      const selectedCategory = findObjectFromArrayOfObjects(supplierCategories, value, '_id');
      if (selectedCategory) {
        newSupplier.categoryMaskCodePrefix = selectedCategory.maskCodePrefix;
        newSupplier.systemCode = getGeneratedMaskCodeCLient(selectedCategory._id, supplierCategories, selectedCategory.maskCodePrefix); // New With Updated Prefix
      }

      // If Category: Retail: Add 000000000, do not validate VAT number. Field not mandatory
      if (newSupplierData.categoryName === 'Retail' || newSupplierData.categoryName === 'Patient') {
        newSupplierData.vatNumber = "000000000";
      } else {
        newSupplierData.vatNumber = "";
      }
      if (newSupplierData.categoryName === "Supplier within E.U.") {
        // Update country list for inside EU.
        // Supplier inside E.U., show only countries within E.U. except Greece
        let EuCountryData = getCountryOptions("insideEU");
        setCountriesList(EuCountryData);
      } else if (newSupplierData.categoryName === "Supplier outside E.U.") {
        // Update country list for outside EU
        // outside E.U., show only countries outside E.U.
        let NonEuCountryData = getCountryOptions("outsideEU");
        setCountriesList(NonEuCountryData);
      } else if (newSupplierData.categoryName === "Retail" || newSupplierData.categoryName === "Patient") {
        setCountriesList(getCountryOptions('all'));
        newSupplierData.country = "GR";
      } else {
        // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.:
        // Select Greece, Accept only Greece, show only Greece
        let onlyGreeceCountryData = getCountryOptions("greece");
        setCountriesList(onlyGreeceCountryData);
        if (onlyGreeceCountryData?.length > 0) {
          newSupplierData.country = onlyGreeceCountryData["0"].value;
        }
      }
    } else {
      if (name === 'isActive' && value === 'inactive') {
        setShowSupplierModal(true);
      } else {
        newSupplierData[name] = value;
      }
    }
    vatCategoryList = SUPPLIERS_DATA.newSupplierModal.categoryName === "Supplier within E.U." || SUPPLIERS_DATA.newSupplierModal.categoryName === "Supplier outside E.U." ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
    let updatedContactPoints = SUPPLIERS_DATA.newSupplierModal.contactPoints.slice();
    let newContacts = {
      name: newSupplier.name,
      email: newSupplier.email,
      mobile: newSupplier.phone
    }
    if (e) {
      if (name === "name") {
        newContacts["name"] = value;
      } else if (name === "email") {
        newContacts["email"] = value;
      } else if (name === "phone") {
        newContacts["mobile"] = value;
      } else if (name === "category") {
        newContacts["mobile"] = "";
      }
    }

    updatedContactPoints["0"] = {
      ...updatedContactPoints["0"],
      ...newContacts,
    };
    newSupplier = {...newSupplier, ...newSupplierData};

    // Default Installation
    let defaultInstallation = [
      {
        id: 0,
        no: 0,
        type: getMainInstallation()?.value,
        address: newSupplier.address,
        DOY: newSupplier.DOY,
        city: newSupplier.city,
        county: newSupplier.county,
        vatCategory: newSupplier.vatCategory,
        vatReason: newSupplier.vatReason,
        customVat: newSupplier.customVat,
        postalCode: newSupplier.postalCode
      },
    ];
    dispatch(
        setNewSupplierModal({
          ...newSupplier,
          contactPoints: updatedContactPoints,
          installations: defaultInstallation,
        })
    );
  }

  const fetchTaxisNetDetails = async (data) => {
    let jsonData = {
      vatNumber: data,
      onlyAADE: "true"
    }
    if (data === "" || data === undefined) {
      return toast.error("Παρακαλώ εισάγετε ΑΦΜ για έλεγχο.");
    }
    const abort = axios.CancelToken.source();
    const timer = setTimeout(
        () => abort.cancel(`timeout`),
        10000
    )
    await axios.post(apiURL2 + `/supplier/fetch-vat-details/`, JSON.stringify(jsonData), {headers: {'Content-Type': 'application/json'}})
        .then((res) => {
          if (res.data && res.data.status === "200") {
            clearTimeout(timer)
            let companyDetails = res.data.data;
            let newSupplier = Object.assign({}, SUPPLIERS_DATA.newSupplierModal);
            newSupplier.name = companyDetails?.name !== undefined ? companyDetails?.name : "";
            newSupplier.smallName = companyDetails?.smallName !== undefined ? companyDetails?.smallName : "";
            newSupplier.activity = companyDetails?.activity !== undefined ? companyDetails?.activity : "";
            newSupplier.postalCode = companyDetails?.tk !== undefined ? companyDetails?.tk : "";
            newSupplier.address = companyDetails?.address !== undefined ? companyDetails?.address : "";
            newSupplier.DOY = getDefaultOptionByValue(getDOYOptions(), companyDetails?.doy, "label", "label", "value").value;
            newSupplier.city = companyDetails?.city !== undefined ? companyDetails?.city : "";
            if (companyDetails?.vatCategory === 'Y') {
              newSupplier.vatCategory = 'Normal VAT';
            }
            let updatedContactPoints = SUPPLIERS_DATA.newSupplierModal.contactPoints.slice();
            let newContacts = {
              name: newSupplier.name,
              email: newSupplier.email,
              mobile: newSupplier.phone,
            };
            updatedContactPoints["0"] = {
              ...updatedContactPoints["0"],
              ...newContacts,
            };
            let defaultInstallation = [
              {
                id: 0,
                no: 0,
                type: getMainInstallation()?.value,
                address: newSupplier.address,
                DOY: newSupplier.DOY,
                city: newSupplier.city,
                county: newSupplier.county,
                vatCategory: newSupplier.vatCategory,
                vatReason: newSupplier.vatReason,
                customVat: newSupplier.customVat,
                postalCode: newSupplier.postalCode
              },
            ];
            dispatch(setNewSupplierModal({
              ...newSupplier,
              contactPoints: updatedContactPoints,
              installations: defaultInstallation
            }));
            toast.success(res.data.message);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response?.status === 400) {
            alert({
              message: error.response.data?.Error ? error.response.data?.Error : error?.message === "timeout" ? "Timeout. Please try again later!" : error.code,
              type: 'warning',
            })
          }
        });
  }

  const handleCancelSupplierModal = () => {
    setShowSupplierModal(false);
    dispatch(resetNewSupplierModal());    // Set New Supplier
  }

  const handleSupplierCategories = () => {
    if (myDataType) {
      let clArray = [];
      let allCategories = getObjectFromArrayOfObjects(SUPPLIERS_DATA.suppliersSettings.categories, 'active', 'isActive');
      allCategories.map((category) => {
        if (myDataType === "1.1" ||
            myDataType === "1.4" ||
            myDataType === "1.5" ||
            myDataType === "1.6" ||
            myDataType === "2.1" ||
            myDataType === "2.4" ||
            myDataType === "3.1" ||
            myDataType === "3.2" ||
            myDataType === "5.1" ||
            myDataType === "5.2" ||
            myDataType === "6.1" ||
            myDataType === "6.2" ||
            myDataType === "7.1" ||
            myDataType === "8.1" ||
            myDataType === "14.1" ||
            myDataType === "14.2" ||
            myDataType === "14.3" ||
            myDataType === "14.4" ||
            myDataType === "14.5" ||
            myDataType === "14.30" ||
            myDataType === "14.31" ||
            myDataType === "15.1" ||
            myDataType === "16.1") {
          if (category.category !== 'Retail' && category.category !== 'Patient' && category.category !== 'Supplier within E.U.' && category.category !== 'Supplier outside E.U.') {
            clArray.push(category);
          }
        } else if (myDataType === "8.2" || myDataType === "11.1" || myDataType === "11.2" || myDataType === "11.3" || myDataType === "11.4" || myDataType === "11.5" || myDataType === "13.1" || myDataType === "13.2" || myDataType === "13.3" || myDataType === "13.4" || myDataType === "13.30" || myDataType === "13.31") {
          if (category.category === 'Retail' || category.category === 'Patient') {
            clArray.push(category);
          }
        } else if (myDataType === "1.2" || myDataType === "2.2") {
          if (category.category === 'Supplier within E.U.') {
            clArray.push(category);
          }
        } else if (myDataType === "1.3" || myDataType === "2.3") {
          if (category.category === 'Supplier outside E.U.') {
            clArray.push(category);
          }
        } else if (["9.3", "10.1", "10.2"].includes(myDataType)) {
          clArray.push(category);
        }
        return category;
      })
      setSupplierCategories(clArray);
    }
  }

  const handleSaveSupplierModal = () => {
    let newSupplierData = {...SUPPLIERS_DATA.newSupplierModal, ...requestData}
    let validCheck = true;
    let isValidVatNumber = true;
    let isValidDOY = true;
    let isValidActivity = true;
    let isValidCountry = true;
    let isValidAddress = true;
    let isValidCity = true;
    let isValidPC = true;
    let isValidVatCategory = true;
    let isValidEmailPhone = true;

    // Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.:  Mandatory field
    if (newSupplierData.categoryName === 'Freelancer' ||
        newSupplierData.categoryName === 'O.E.' ||
        newSupplierData.categoryName === 'E.E.' ||
        newSupplierData.categoryName === 'E.P.E.' ||
        newSupplierData.categoryName === 'I.K.E.' ||
        newSupplierData.categoryName === "Non-Profit Organization" ||
        newSupplierData.categoryName === 'Wholesale Others' ||
        newSupplierData.categoryName === 'A.E.') {
      if (newSupplierData.vatNumber === '') {
        isValidVatNumber = false;
      }
      if (newSupplierData.DOY === '' && newSupplierData.categoryName !== "Supplier within E.U." && newSupplierData.categoryName !== "Supplier outside E.U.") {
        isValidDOY = false;
      }
    }

    // Mandatory field EXCEPT if category retail & patient
    if (
        newSupplierData.categoryName !== 'Retail' &&
        newSupplierData.categoryName !== 'Patient'
    ) {
      if (newSupplierData.activity === '' && newSupplierData.categoryName !== "Supplier within E.U." && newSupplierData.categoryName !== "Supplier outside E.U.") {
        isValidActivity = false;
      }
      if (newSupplierData.country === '') {
        isValidCountry = false;
      }
      if (newSupplierData.address === '') {
        isValidAddress = false;
      }
      if (newSupplierData.city === '') {
        isValidCity = false;
      }
      if (newSupplierData.postalCode === '') {
        isValidPC = false;
      }
    }

    // Do not show if Supplier Category is "Supplier within E.U." or "Supplier outside E.U."
    if (newSupplierData.vatCategory === '' && newSupplierData.categoryName !== 'Supplier within E.U.' && newSupplierData.categoryName !== 'Supplier outside E.U.') {
      isValidVatCategory = false
    }
    if (newSupplierData.email === "" && newSupplierData.phone === "") {
      isValidEmailPhone = false;
    }

    if (
        newSupplierData.category === '' ||
        newSupplierData.name === '' ||
        !isValidVatNumber ||
        !isValidDOY ||
        !isValidActivity ||
        !isValidCountry ||
        !isValidAddress ||
        !isValidCity ||
        !isValidPC ||
        !isValidEmailPhone ||
        !isValidVatCategory
    ) {
      toast.error('Please check all mandatory fields.');
      validCheck = false
    }
    if (validateAFM(newSupplierData.vatNumber) === false &&
        (newSupplierData.categoryName === "Freelancer" ||
            newSupplierData.categoryName === "O.E." ||
            newSupplierData.categoryName === "E.E." ||
            newSupplierData.categoryName === "E.P.E." ||
            newSupplierData.categoryName === 'Wholesale Others' ||
            newSupplierData.categoryName === "I.K.E." ||
            newSupplierData.categoryName === "Non-Profit Organization" ||
            newSupplierData.categoryName === "A.E.")) {
      toast.error("Vat Number is wrong. Please check again!");
      validCheck = false;
    }

    if (validCheck) {
      setLoadingSave(true);
      axios.post(`${apiURL2}/supplier/add-supplier`, newSupplierData, {
        headers: {'Content-Type': 'application/json'}
      }).then((res) => {
        if (res.data && res.data.status === '200') {
          toast.success("Supplier added successfully.");
          dispatch(fetchInitialSuppliers(requestData));  // Fetch list again
          dispatch(resetNewSupplierModal());
          setShowSupplierModal(false); // Close modal

          if (successCallback && typeof successCallback === "function") successCallback(res.data.data);
        } else {
          toast.error(res.data.message);
        }
        setLoadingSave(false);
      }).catch((error) => {
        if (error && error.response && error.response.data && error.response.data.errors) {
          toast.error(error.response.data.errors);
          setShowSupplierModal(false); // Close modal
        }
        setLoadingSave(false);
      })
    }
  }

  return (
      <div className="new-supplier-modal">
        <i title={`Προσθήκη νέου πελάτη`} onClick={() => {
          setShowSupplierModal(true);
          handleSupplierCategories();
        }} className='fas border ml-2 fa-plus add-supplier-icon'></i>
        <Modal backdrop={"static"} size="xl" className="themeModal" show={showSupplierModal}
               onHide={() => handleCancelSupplierModal()}>
          <Modal.Header closeButton>
            <Modal.Title>{t('NewClientModal.message')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='new-supplier-modal-body'>
            {disabledFields && <div className="overlay_w">{t('NewClientModal.message2')}</div>}
            <Row className={"mb-2"}>
              <Col sm={12} md={3}
                   className={SUPPLIERS_DATA.newSupplierModal.category === '' ? "showWithOverlay" : ""}>
                <Dropdown
                    label={t('NewClientModal.category')}
                    required={true}
                    options={supplierCategoriesOption}
                    classes="w-100 mb-2"
                    name="category"
                    isCLientCategory={true}
                    key={Math.random()}
                    defaultValue={getDefaultOptionByValue(supplierCategories, SUPPLIERS_DATA.newSupplierModal.category, '_id', 'category', '_id')}
                    onChange={(e) => handleOnChange(e, 'dd', 'category')}
                />
              </Col>
              <Col sm='12' md="3">
                <Input
                    label={t('NewClientModal.systemCode.systemCode')}
                    className="w-100"
                    disabled={true}
                    name="systemCode"
                    value={getMaskCodeWithNewPrefix(SUPPLIERS_DATA.newSupplierModal.systemCode, SUPPLIERS_DATA.newSupplierModal.categoryMaskCodePrefix)}
                    placeholder={t('NewClientModal.systemCode.placeholder')}
                />
              </Col>
            </Row>
            <Row className={"mb-2"}>
              <Col sm='12' md="3">
                <Input
                    label={t('NewClientModal.name.name')}
                    required={true}
                    className="w-100"
                    name="name"
                    type="text"
                    value={SUPPLIERS_DATA.newSupplierModal.name}
                    placeholder={t('NewClientModal.name.placeholder')}
                    onChange={(e) => handleOnChange(e)}
                />
                {showErrors && SUPPLIERS_DATA.newSupplierModal.name === '' &&
                    <div className="text-danger">{t('NewClientModal.name.required')}</div>}
              </Col>
              <Col sm='12' md="3">
                <div className='mb-2'>
                  <Input
                      label={t('NewClientModal.email.email')}
                      className="w-100"
                      name="email"
                      type="email"
                      value={SUPPLIERS_DATA.newSupplierModal.email}
                      placeholder={t('NewClientModal.email.placeholder')}
                      onChange={(e) => handleOnChange(e)}
                  />
                  {showErrors &&
                      SUPPLIERS_DATA.newSupplierModal.email === '' && !isValidEmail(SUPPLIERS_DATA.newSupplierModal.email) && SUPPLIERS_DATA.newSupplierModal.categoryName !== "Patient" &&
                      <div className="text-danger">{t('NewClientModal.email.required')}</div>
                  }
                </div>
              </Col>

              <Col sm='12' md="3">
                <Input
                    label={t('NewClientModal.phone.phone')}
                    className="w-100"
                    name="phone"
                    type="tel"
                    charLimit={20}
                    value={SUPPLIERS_DATA.newSupplierModal.phone}
                    placeholder={t('NewClientModal.phone.placeholder')}
                    onChange={(e) => handleOnChange(e)}
                />
              </Col>

              {/* Do not show if Supplier Category is "Supplier within E.U." or "Supplier outside E.U." */}
              <Col sm='12' md="3">
                <div className='mb-2'>
                  <Dropdown
                      label={t('NewClientModal.vatCategory.vatCategory')}
                      classes="w-100"
                      required={true}
                      name="vatCategory"
                      key={Math.random()}
                      defaultValue={getDefaultOptionByValue(vatCategoryList, SUPPLIERS_DATA.newSupplierModal.vatCategory, 'value', 'label', 'value')}
                      options={vatCategoryList}
                      onChange={(e) => handleOnChange(e, 'dd', 'vatCategory')}
                  />
                  {showErrors && SUPPLIERS_DATA.newSupplierModal.vatCategory === '' &&
                      <div className="text-danger">{t('NewClientModal.vatCategory.requirement')}</div>}
                </div>
              </Col>
              {(SUPPLIERS_DATA.newSupplierModal.vatCategory !== "" && SUPPLIERS_DATA.newSupplierModal.vatCategory === 'Zero VAT') && (
                  <Col sm="12" md="4">
                    <div className="mb-2">
                      <Dropdown
                          classes='w-100'
                          label={t('NewClientModal.0%VatReason.0%VatReason')}
                          key={Math.random()}
                          name="vatReason"
                          required={true}
                          options={zeroVatReasonOptions}
                          defaultValue={SUPPLIERS_DATA.newSupplierModal.vatReason ? {
                            value: SUPPLIERS_DATA.newSupplierModal.vatReason,
                            label: getLabelByValue(zeroVatReasonOptions, SUPPLIERS_DATA.newSupplierModal.vatReason, 'value'),
                            color: "#76AEB7"
                          } : null}
                          onChange={(e) => handleOnChange(e, 'dd', 'vatReason')}
                      />
                      {showErrors && SUPPLIERS_DATA.newSupplierModal.vatCategory === 'Zero VAT' && SUPPLIERS_DATA.newSupplierModal.vatReason === "" && (
                          <div className="text-danger">{t('NewClientModal.0%VatReason.required')}</div>
                      )}
                    </div>
                  </Col>
              )}
              {(SUPPLIERS_DATA.newSupplierModal.vatCategory !== "" && SUPPLIERS_DATA.newSupplierModal.vatCategory === 'Custom VAT') &&
                  <Col xs="12" md="4">
                    <div className="mb-2">
                      <Input
                          name="customVat"
                          type="number"
                          validate={isValidCustomVat}
                          placeholder={t('NewClientModal.customVat.placeholder')}
                          label={t('NewClientModal.customVat.customVat')}
                          charLimit={3}
                          onChange={(e) => handleOnChange(e)}
                          value={SUPPLIERS_DATA.newSupplierModal.customVat}
                      />
                      {(SUPPLIERS_DATA.newSupplierModal.vatCategory === 'Custom VAT' &&
                              SUPPLIERS_DATA.newSupplierModal.customVat === "") &&
                          <div className="text-danger">{t('NewClientModal.customVat.required')}</div>
                      }
                    </div>
                  </Col>
              }
            </Row>
            <Row className={"mb-2"}>
              {/* Retail: Add 999999999, do not validate VAT number. Field not mandatory */}
              {/* Supplier inside E.U.,outside E.U., Do not validate VAT, do not enter anything. Not mandatory field */}
              {(SUPPLIERS_DATA.newSupplierModal.categoryName === 'Supplier within E.U.' || SUPPLIERS_DATA.newSupplierModal.categoryName === 'Supplier outside E.U.' || SUPPLIERS_DATA.newSupplierModal.categoryName === 'Retail') &&
                  <Col sm='12' md="3">
                    <Input
                        label={t('NewClientModal.vatNumber.vatNumber')}
                        className="w-100 bg-white"
                        name="vatNumber"
                        charLimit={20}
                        type="number"
                        value={SUPPLIERS_DATA.newSupplierModal.vatNumber}
                        placeholder={t("General.vatNumber")}
                        onChange={(e) => handleOnChange(e)}
                    />
                  </Col>
              }

              {/* Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.: Validate VAT number, use "Get Details" button to get company details. Mandatory field */}
              {(
                      SUPPLIERS_DATA.newSupplierModal.categoryName === 'Freelancer' ||
                      SUPPLIERS_DATA.newSupplierModal.categoryName === 'O.E.' ||
                      SUPPLIERS_DATA.newSupplierModal.categoryName === 'E.E.' ||
                      SUPPLIERS_DATA.newSupplierModal.categoryName === 'E.P.E.' ||
                      SUPPLIERS_DATA.newSupplierModal.categoryName === 'Wholesale Others' ||
                      SUPPLIERS_DATA.newSupplierModal.categoryName === 'I.K.E.' ||
                      SUPPLIERS_DATA.newSupplierModal.categoryName === "Non-Profit Organization" ||
                      SUPPLIERS_DATA.newSupplierModal.categoryName === 'A.E.'
                  ) &&
                  <Col sm='12' md="4">
                    <div className='mb-2'>
                      <Input
                          label={t('NewClientModal.vatNumber2.vatNumber2')}
                          className="w-100 bg-white"
                          name="vatNumber"
                          required={true}
                          charLimit={20}
                          type="number"
                          value={SUPPLIERS_DATA.newSupplierModal.vatNumber}
                          placeholder={t('NewClientModal.vatNumber2.placeholder')}
                          onChange={(e) => handleOnChange(e)}
                      />
                      {showErrors && SUPPLIERS_DATA.newSupplierModal.vatNumber === '' &&
                          <div className="text-danger">{t('NewClientModal.vatNumber2.required')}</div>}
                    </div>
                  </Col>
              }

              {/* Show only if category is NOT Retail or Patient */}
              {/* Use "Get Greek Company Details from taxisnet" algorithm */}
              {(SUPPLIERS_DATA.newSupplierModal.categoryName !== '' &&
                      SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail' &&
                      SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Patient') &&
                  <Col sm='12' md="2" className="d-flex align-items-center">
                    <Button onClick={() => fetchTaxisNetDetails(SUPPLIERS_DATA.newSupplierModal.vatNumber)}
                            size="sm" className="mb-2"
                            type='button'>{t('NewClientModal.getDetails')}</Button>
                  </Col>
              }

              <Col sm='12' md="3">
                {/* Retail or patient: not mandatory fields
                  Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.:  Mandatory field
                  Supplier inside E.U.,outside E.U., Not mandatory field */}
                <Dropdown
                    label={t('NewClientModal.doy.doy')}
                    classes="w-100"
                    required={(SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail' && SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Supplier within E.U.' && SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Supplier outside E.U.')}
                    searchEnable={true}
                    name="DOY"
                    key={Math.random()}
                    defaultValue={getDefaultOptionByValue(getDOYOptions(), SUPPLIERS_DATA.newSupplierModal.DOY, 'value', 'label', 'value')}
                    options={getDOYOptions()}
                    onChange={(e) => handleOnChange(e, 'dd', 'DOY')}
                />
                {(
                        SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail' &&
                        SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Patient' &&
                        SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Supplier within E.U.' &&
                        SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Supplier outside E.U.'
                    ) &&
                    showErrors &&
                    SUPPLIERS_DATA.newSupplierModal.DOY === '' &&
                    <div className="text-danger">{t('NewClientModal.doy.required')}</div>
                }
              </Col>
              <Col sm="12" md="3">
                <Input
                    label={t('NewClientModal.activity.activity')}
                    className="w-100"
                    name="activity"
                    type="text"
                    charLimit={100}
                    required={
                        SUPPLIERS_DATA.newSupplierModal.categoryName !== "Retail" &&
                        SUPPLIERS_DATA.newSupplierModal.categoryName !== "Patient"
                    }
                    value={SUPPLIERS_DATA.newSupplierModal.activity}
                    placeholder={t('NewClientModal.activity.placeholder')}
                    onChange={(e) => handleOnChange(e)}
                />
                {SUPPLIERS_DATA.newSupplierModal.categoryName !== "Retail" &&
                    SUPPLIERS_DATA.newSupplierModal.categoryName !== "Patient" &&
                    showErrors &&
                    SUPPLIERS_DATA.newSupplierModal.activity === "" && (
                        <div className="text-danger">{t('NewClientModal.activity.required')}</div>
                    )}
              </Col>
            </Row>
            <Row>
              <Col sm='12' md="3">
                {/* Mandatory field EXCEPT if category retail & patient */}
                <Dropdown
                    label={t('NewClientModal.country.country')}
                    classes="w-100"
                    required={(SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail' && SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Patient')}
                    name="country"
                    searchEnable={true}
                    key={Math.random()}
                    defaultValue={getDefaultOptionByValue(countriesList, SUPPLIERS_DATA.newSupplierModal.country, 'value', 'label', 'value')}
                    options={countriesList}
                    onChange={(e) => handleOnChange(e, 'dd', 'country')}
                />
                {(SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail' &&
                        SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Patient') &&
                    showErrors &&
                    SUPPLIERS_DATA.newSupplierModal.country === '' &&
                    <div className="text-danger">{t('NewClientModal.country.required')}</div>
                }
              </Col>
              <Col sm='12' md="3">
                <div className='mb-2'>
                  {/* Mandatory field EXCEPT if category retail & patient */}
                  <Input
                      label={t('NewClientModal.address.address')}
                      className="w-100"
                      name="address"
                      type="text"
                      charLimit={100}
                      required={(SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail')}
                      value={SUPPLIERS_DATA.newSupplierModal.address}
                      placeholder={t('NewClientModal.address.placeholder')}
                      onChange={(e) => handleOnChange(e)}
                  />
                  {(SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail') &&
                      showErrors &&
                      SUPPLIERS_DATA.newSupplierModal.address === '' &&
                      <div className="text-danger">{t('NewClientModal.address.required')}</div>
                  }
                </div>
              </Col>
              <Col sm="12" md="3">
                <div className="mb-2">
                  {/* Mandatory field EXCEPT if category retail & patient */}
                  <Input
                      label={t('NewClientModal.city.city')}
                      className="w-100"
                      name="city"
                      type="text"
                      charLimit={100}
                      required={
                          SUPPLIERS_DATA.newSupplierModal.categoryName !== "Retail" &&
                          SUPPLIERS_DATA.newSupplierModal.categoryName !== "Patient"
                      }
                      value={SUPPLIERS_DATA.newSupplierModal.city}
                      placeholder={t('NewClientModal.city.placeholder')}
                      onChange={(e) => handleOnChange(e)}
                  />
                  {SUPPLIERS_DATA.newSupplierModal.categoryName !== "Retail" &&
                      SUPPLIERS_DATA.newSupplierModal.categoryName !== "Patient" &&
                      showErrors &&
                      SUPPLIERS_DATA.newSupplierModal.city === "" && (
                          <div className="text-danger">{t('NewClientModal.city.required')}</div>
                      )}
                </div>
              </Col>
              <Col sm='12' md="3">
                {/* Mandatory field EXCEPT if category retail & patient */}
                <div className='mb-2'>
                  <Input
                      label={t('NewClientModal.postalCode.postalCode')}
                      className="w-100"
                      name="postalCode"
                      type="text"
                      required={(SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail' && SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Patient')}
                      value={SUPPLIERS_DATA.newSupplierModal.postalCode}
                      placeholder={t('NewClientModal.postalCode.placeholder')}
                      onChange={(e) => handleOnChange(e)}
                  />
                  {(SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Retail' &&
                          SUPPLIERS_DATA.newSupplierModal.categoryName !== 'Patient') &&
                      showErrors &&
                      SUPPLIERS_DATA.newSupplierModal.postalCode === '' &&
                      <div className="text-danger">{t('NewClientModal.postalCode.required')}</div>
                  }
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={loadingSave} variant="outline-primary"
                    onClick={() => handleCancelSupplierModal()}>{t('NewClientModal.cancel')}</Button>
            <Button disabled={loadingSave} variant="primary" onClick={() => handleSaveSupplierModal()}>
              {
                  loadingSave &&
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              }
              {t('NewClientModal.save')}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
  )
}

export default NewSupplierModal;
